export const gaEvent = (event_name, event_action, event_label, record_id) => {
  if (window.gtag) {
    const sua_id = localStorage.getItem("sua_id");
    const params = {
      event_action,
      event_label,
      transport_type: "beacon",
      user_id: sua_id,
    };

    if (record_id !== undefined && record_id !== null && record_id !== "") {
      params.record_id = record_id;
    }

    // if (sua_id) {
    //   params.user_id = sua_id;
    // }

    //  console.log(params);

    window.gtag("event", event_name, params);
  }
};
